import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { NotebookMessageRepository } from "@notebook/domain/repositories/notebook-message.repository";
import { notebookTypes } from "@notebook/notebook-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class NotebookMessageFileDeleteUseCase {
    constructor(
        @inject(notebookTypes.repositories.NotebookMessageRepository)
        private readonly notebookMessageRepository: NotebookMessageRepository,
    ) {}

    async execute(
        notebookId: string,
        notebookMessageId: string,
        fileId: string,
    ): Promise<boolean> {
        const result = await this.notebookMessageRepository.deleteFile(
            notebookId,
            notebookMessageId,
            fileId,
        );

        if (result.isErr()) {
            ToastManagerRepository.error(result.error.message);
        }

        return result.isOk();
    }
}
